import React, { useRef, useEffect, useContext, useReducer, useState } from "react";
import { Badge, makeStyles, Typography, IconButton, LinearProgress, Popper, Paper, ClickAwayListener } from "@material-ui/core";
import { BellIcon } from "../icons";
import { socket } from "../helpers";
import { AuthContext } from "../context";
import { doctorServices } from "../services";

function reducer(prevState, action) {
  switch (action.type) {
    case "SETQUANTITY":
      return {
        ...prevState,
        quantity: action.quantity,
      };
    case "ADDTOP":
      return {
        ...prevState,
        notifications: [action.value, ...prevState.notifications],
      };
    case "ADDBOTTOM":
      return {
        ...prevState,
        notifications: [...prevState.notifications, action.value],
      };
    case "UPDATESTATUS":
      return {
        notifications: prevState.notifications.map((obj) => {
          return {
            ...obj,
            read: true,
          };
        }),
      };
    case "QUANTITY":
      return {
        ...prevState,
        quantity: prevState.quantity + 1,
      };
    case "CLEAR":
      return {
        ...prevState,
        quantity: 0,
      };
    default:
      return { ...prevState };
  }
}

export default function NotificationComponent(props) {
  const [loading, setLoading] = useState(false);
  const classes = useStyles({ loading })();
  const [anchorEl, setAnchorEl] = useState(null);
  const [page, setPage] = useState(1);
  const divRef = useRef();
  const [open, setOpen] = useState(Boolean(anchorEl));
  const {
    authState: {
      user: {
        doctor: { _id },
      },
      token,
    },
  } = useContext(AuthContext);
  const [state, dispatch] = useReducer(reducer, { quantity: 0, notifications: [] });

  useEffect(() => {
    async function getNotifications() {
      try {
        setLoading(true);
        const { status, response } = await doctorServices.getNotifications({ doctorId: _id, token, page, limit: 4 });
        setLoading(false);
        if (status === 200) {
          response.notifications.forEach((notification) => {
            if (page === 1) {
              dispatch({ type: "ADDBOTTOM", value: notification });
            } else dispatch({ type: "ADDBOTTOM", value: notification });
            if (!notification.read) {
              dispatch({ type: "QUANTITY" });
            }
          });
        }
      } catch (e) {}
    }
    getNotifications();
  }, [_id, token, page]);

  // useEffect(() => {
  //     if (!("Notification" in window)) {
  //         socket.on(`${_id}`, (socket) => {
  //             dispatch({ type:"ADDTOP", value:socket.notification });
  //         })
  //     }
  //     else if(Notification.permission==="granted"){
  //         socket.on(`${_id}`, (socket) => {
  //             dispatch({ type:"ADDTOP", value:socket.notification });
  //             dispatch({type:"QUANTITY"})
  //             //navigator.serviceWorker.register('./service-worker.js');
  //             navigator.serviceWorker.ready.then(function(registration) {
  //                 registration.showNotification('Productos', {
  //                     body:`${socket.notification.message}`,
  //                 });
  //             })
  //         })
  //     }
  // }, [_id])

  const handleClose = async () => {
    setOpen(false);
    const notifications = state.notifications.map((obj) => obj._id);
    if (state.quantity > 0) {
      try {
        const { status } = await doctorServices.updateNotificationsStatus({ token, notifications });
        if (status === 200) {
          dispatch({ type: "UPDATESTATUS" });
          dispatch({ type: "CLEAR" });
        }
      } catch (e) {
        console.log(e);
      }
    }
  };

  const onScroll = () => {
    const {
      current: { scrollHeight, scrollTop, clientHeight },
    } = divRef;
    if (scrollHeight - scrollTop === clientHeight && !loading) {
      setPage(page + 1);
    }
  };

  return (
    <div>
      <IconButton
        onClick={(event) => {
          setAnchorEl(event.currentTarget);
          setOpen(!open);
        }}
      >
        <Badge badgeContent={state.quantity} color="primary">
          <BellIcon />
        </Badge>
      </IconButton>
      <Popper placement={"bottom-end"} open={open} anchorEl={anchorEl} className={classes.popover}>
        <ClickAwayListener onClickAway={handleClose}>
          <Paper>
            <ul className={classes.ul} ref={divRef} onScroll={onScroll}>
              {state.notifications.map((el, index) => (
                <li key={index} className={`${classes.li} ${el.read ? classes.read : classes.unRead}`}>
                  <Typography color="inherit">{el.message}</Typography>
                </li>
              ))}
            </ul>
            {loading && <LinearProgress color="secondary" className={classes.progress} />}
          </Paper>
        </ClickAwayListener>
      </Popper>
    </div>
  );
}

const useStyles = ({ loading }) =>
  makeStyles((theme) => ({
    popover: {
      "& .MuiPaper-root": {
        backgroundColor: "#FFF",
        color: "rgba(0, 0, 0, 0.87)",
        fontSize: theme.typography.pxToRem(12),
        borderRadius: 12,
        margin: "5px 0 0 0",
        padding: loading ? "15px 0 0 0" : "15px 0",
        maxWidth: 259,
        boxShadow: "0px 3px 3px -2px rgb(0 0 0 / 20%), 0px 3px 4px 0px rgb(0 0 0 / 14%), 0px 1px 8px 0px rgb(0 0 0 / 12%)",
        "&::before": {
          content: '""',
          position: "absolute",
          top: -9,
          right: 14,
          width: 9,
          height: 9,
          backgroundColor: theme.palette.secondary.main,
          boxShadow: theme.shadows[1],
          transform: "translate(-50%, 50%) rotate(317deg)",
          clipPath: "polygon(-5px -5px, calc(100% + 5px) -5px, calc(100% + 5px) calc(100% + 5px))",
        },
      },
    },
    read: {
      "&:before": {
        content: "url('../../assets/ellipse-2.svg')",
      },
    },
    unRead: {
      "&:before": {
        content: "url('../../assets/ellipse-1.svg')",
      },
      "& p": {
        fontWeight: "600",
      },
    },
    li: {
      "&:before": {
        position: "absolute",
        left: 20,
      },
      "& p": {
        fontSize: "0.813rem",
        lineHeight: "1rem",
        color: "#192A7F",
      },
      margin: "0 0 17px 0",
    },
    ul: {
      listStyle: "none",
      marginLeft: 0,
      position: "relative",
      maxHeight: 171,
      overflowY: "scroll",
    },
    progress: {
      height: 12,
    },
  }));
